import {Map, OrderedMap} from 'immutable'
import fetchJSON from 'lib/fetchJSON'
import {fulfilled} from 'lib/promiseMiddlewareHelpers'

export const ADD = 'comments/ADD'
export const DELETE = 'comments/DELETE'
export const LOAD = 'comments/LOAD'

// The main data structure in the state is a multi-level map 'parent_type' -> 'parent_id' -> OrderedMap(id -> comment)

export const reducer = (state = Map(), action = {}) => {
  switch (action.type) {
    case fulfilled(ADD): {
      const {parentType, parentId} = action.meta
      return state.setIn([parentType, parentId, 'comments', action.payload.id], action.payload)
    }
    case fulfilled(DELETE): {
      const {parentType, parentId, commentId} = action.meta
      return state.deleteIn([parentType, parentId, 'comments', commentId])
    }
    case fulfilled(LOAD): {
      const {parentType, parentId} = action.meta
      const comments = OrderedMap(action.payload.comments.map(comment => [comment.id, comment]))
      return state.updateIn([parentType, parentId, 'comments'], () => comments)
    }
    default:
      return state
  }
}

export const submitComment = (parentType, parentId, comment) => ({
  type: ADD,
  payload: fetchJSON(`/comments.json`, {
    parent_type: parentType,
    parent_id: parentId,
    response_as_data: true,
    comment}, {method: 'POST'}),
  meta: {parentId, parentType}
})

export const deleteComment = (parentType, parentId, commentId) => ({
  type: DELETE,
  payload: fetchJSON(`/comments/${commentId}.json`, {}, {method: 'DELETE'}),
  meta: {parentType, parentId, commentId}
})

export const loadComments = (parentType, parentId, privacyCode) => ({
  type: LOAD,
  payload: fetchJSON(`/comments.json?parent_type=${parentType}&parent_id=${parentId}${privacyCode ? `&privacy_code=${privacyCode}` : ''}`),
  meta: {parentId, parentType}
})
